<template>
  <main id="contents" class="live">
    <LiveTitle />
    <SuperMultiSection />
  </main>
</template>
<script>
  import SuperMultiSection from '@/components/container/SuperMultiSection'
  import { scrollTop, setDisableScrolling, titleTagNameChange } from '@/common/utils/common'
  import { mapMutations } from 'vuex'
  import { MENU, SET_CURRENT_MENU } from '@/common/resources/const'
  import LiveTitle from '@/components/live/LiveTitle'
  import { setReferer } from '@/common/utils/referer'
  import { PATH_NAME_LIVE } from '@/common/resources/router.const'
  export default {
    name: 'Live',
    components: {
      LiveTitle,
      SuperMultiSection
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU])
    },
    created () {
      scrollTop()
      setDisableScrolling(false)
      titleTagNameChange('웨이브 LIVE')
      setReferer(`/${PATH_NAME_LIVE}`)
      this[SET_CURRENT_MENU](MENU.LIVE)
    }
  }
</script>
<style lang="scss" src="@/assets/scss/category/live.scss"></style>
